import {
  MessageFormat,
  CurrencyFormat,
  DateTimeFormat,
} from '@paypalcorp/worldready'

export function formatMessage({
  worldReady,
  contentId,
  formatOptions,
}: {
  worldReady: any
  contentId: string
  formatOptions?: any
}): string {
  return new MessageFormat(worldReady, { id: contentId }).format(formatOptions)
}

export function formatCurrency({
  worldReady,
  value,
  currencyCode,
  additionalConfig,
}: {
  worldReady: any
  value: any
  currencyCode: string
  additionalConfig?: object
}): string {
  if (!currencyCode) {
    return null
  }
  return new CurrencyFormat(worldReady, {
    currency: currencyCode,
    ...additionalConfig,
  }).format(value)
}

export function formatDate({
  worldReady,
  value,
}: {
  worldReady: any
  value: Date | string
}) {
  const date = value instanceof Date ? value : new Date(value)
  return new DateTimeFormat(worldReady, {
    style: 'date-medium',
    timeZone: '',
  }).format(date)
}

export function parseFormattedDate({
  worldReady,
  value,
  timeZone,
}: {
  worldReady: any
  value: string
  timeZone: string
}) {
  const dateTimeFormatter = new DateTimeFormat(worldReady, {
    style: 'date-medium',
    timeZone: timeZone || 'Etc/UTC',
  })
  const parsedDate = dateTimeFormatter.parse(value)
  return parsedDate
}
